import React from 'react';

import { box, CAPTION_HEIGHT, CAPTION_SIZE, CONTENT_WIDTH, MARGIN_X, pt } from '../slideGeometry';

/**
 * A table or chart block's caption, in the top of the block, from the block's
 * own `x` and over its `width` when it has them, at its `captionSize`.
 */
const BlockCaption = ({ block }) =>
    block.caption ? (
        <div
            className="tw-text-charcoal tw-font-bold"
            style={{ ...box(block.x ?? MARGIN_X, block.y, block.width ?? CONTENT_WIDTH, CAPTION_HEIGHT), fontSize: pt(block.captionSize ?? CAPTION_SIZE) }}
        >
            {block.caption}
        </div>
    ) : null;

export default BlockCaption;
